<script setup lang="ts">
import { computed, type Component } from 'vue';

const props = defineProps<{
  block?: {
    _type: string,
    _key: string,
    theme: string,
    content: string,
    inlineStyles?: boolean,
    variant?:string;
  },
  config: {
    innerComponent?: Component
  },
}>();

const data = computed(() => ({
  theme: props.block?.theme,
  content: props.block?.content,
  inlineStyles: props.block?.inlineStyles,
  variant: props.block?.variant,
}));

</script>

<template>
  <div class="wrapper wrapper--content">
    <component :is="props.config?.innerComponent" v-bind="data" />
  </div>
</template>
